<template>
  <div class="kv-tree" :class="{ 'kv-tree-nested': depth > 0 }">
    <template v-for="(item, idx) in entries">
      <div :key="idx" class="kv-row">
        <template v-if="isComplex(item.value)">
          <div class="kv-group-label">{{ formatKey(item.key) }}</div>
          <kv-tree :data="item.value" :depth="depth + 1"></kv-tree>
        </template>
        <template v-else>
          <div class="kv-pair">
            <span class="kv-key">{{ formatKey(item.key) }}</span>
            <span class="kv-value">{{ formatValue(item.value) }}</span>
          </div>
        </template>
      </div>
    </template>
    <div v-if="entries.length === 0" class="kv-empty">(leer)</div>
  </div>
</template>

<script>
export default {
  name: "KvTree",
  props: {
    data: { required: true },
    depth: { type: Number, default: 0 },
  },
  computed: {
    entries() {
      if (this.data === null || this.data === undefined) return []
      if (Array.isArray(this.data)) {
        return this.data.map((v, i) => ({ key: "[" + i + "]", value: v }))
      }
      if (typeof this.data === "object") {
        return Object.keys(this.data).map(k => ({ key: k, value: this.data[k] }))
      }
      return []
    },
  },
  methods: {
    isComplex(v) {
      return v !== null && typeof v === "object"
    },
    formatKey(k) {
      if (typeof k !== "string") return k
      if (k.startsWith("[")) return k
      return k
          .replace(/[_-]+/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/\b\w/g, c => c.toUpperCase())
    },
    formatValue(v) {
      if (v === null || v === undefined) return "—"
      if (typeof v === "boolean") return v ? "Ja" : "Nein"
      if (typeof v === "string" && v.length === 0) return "—"
      return String(v)
    },
  },
}
</script>

<style scoped>
.kv-tree {
  text-align: left;
}

.kv-tree-nested {
  margin-left: 16px;
  padding-left: 12px;
  border-left: 2px solid rgba(255, 255, 255, 0.08);
  margin-top: 4px;
  margin-bottom: 8px;
}

.kv-row {
  padding: 2px 0;
}

.kv-pair {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  padding: 6px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.kv-pair:last-child {
  border-bottom: none;
}

.kv-key {
  color: #888;
  font-size: 13px;
  white-space: nowrap;
}

.kv-value {
  font-family: Consolas, "Courier New", monospace;
  font-size: 14px;
  color: #d4d4d4;
  text-align: right;
  word-break: break-all;
}

.kv-group-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5b9bd5;
  margin-top: 8px;
  margin-bottom: 4px;
  font-weight: 600;
}

.kv-empty {
  color: #666;
  font-style: italic;
  padding: 8px;
}
</style>
